import { Skin } from '#src/__generated__/globalTypes.ts';
import fullArt from '#src/components/collections/SkinIcon/assets/full_art.webp';
import holo from '#src/components/collections/SkinIcon/assets/holo.webp';
import shiny from '#src/components/collections/SkinIcon/assets/shiny.webp';
import standard from '#src/components/collections/SkinIcon/assets/standard.webp';
import { unitMapping } from '#src/lib/style.ts';

const SKIN_IMAGES: Record<Skin, string> = {
  [Skin.FULL_ART]: fullArt,
  [Skin.HOLO]: holo,
  [Skin.SHINY]: shiny,
  [Skin.STANDARD]: standard,
};

type Props = { skin: Nullable<Skin>; size?: keyof typeof unitMapping };

export const SkinIcon = ({ skin, size = 2 }: Props) => {
  const width = unitMapping[size];
  if (!skin) {
    return null;
  }
  return (
    <img src={SKIN_IMAGES[skin]} alt={skin} style={{ width, height: width }} />
  );
};
